

import React, { useEffect, useState } from 'react';
import { Box, Button, Grid, TextField, Typography } from '@mui/material';
import AppraisalFormComponent from './AppraisalFormComponent';
import FileUploadWithPreview from './FileUploadWithPreview';
import PMSRating from './PMSRating';
import EmployeePMSRating from './EmployeePMSRating';
import RatingTable from './RatingTable/RatingTable';
import AppraisalHistory from './AppraisalHistory';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../../ReduxStore/actions';
import { toast, ToastContainer } from 'react-toastify';
import FullPageLoader from '../../../Components/FullPageLoader/FullPageLoader';
// import PDFExport from './AppraisalPdfGenerator';


const getRating = (value) => {
    if (value === null || value === "") return "";

    value = Number(value); // force numeric
    if (value >= 96 && value <= 100) {
        return 'OUTSTANDING';
    } else if (value >= 80 && value <= 95) {
        return 'MEETS ALL EXPECTATIONS';
    } else if (value >= 61 && value <= 79) {
        return 'MEETS MOST EXPECTATIONS';
    } else {
        return 'BELOW EXPECTATION';
    }
};

const MyAppraisalForm = () => {
    const [comments, setComments] = useState('');
    const [appraisalData, setAppraisalData] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [questionSectionData, setQuestionSectionData] = useState([])
    const [responseApiData, setResponseApiData] = useState([])
    console.log('responseApiData', responseApiData);
    const { getKraKpiAppraisalForm } = useSelector((state) => state?.getKraKpiAppraisalForm);
    console.log(getKraKpiAppraisalForm, "getKraKpiAppraisalForm")

    let totalAchievement = 0;
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)


    const handleSubmit = async () => {
        if (!comments) {
            toast.error("Comments is required")
            return
        }

        setLoading(true)
        console.log('Submitted Appraisal Data:', appraisalData?.kra_kpi_questions);
        console.log('Submitted Appraisal Data:', typeof (appraisalData));


        console.log('Uploaded Files:', uploadedFiles);
        console.log('Assessee Comments:', comments);


        appraisalData?.kra_kpi_questions?.forEach(kraObj => {
            const kra = Object.values(kraObj)[0]; // Extract the actual KRA object
            const kpis = kra.KPIs;

            kpis?.forEach(kpiObj => {
                const kpi = Object.values(kpiObj)[0]; // Extract KPI data
                const achievement = parseFloat(kpi.Achievement);
                if (!isNaN(achievement)) {
                    totalAchievement += achievement;
                }
            });
        });

        console.log(totalAchievement, "totalAchievement")

        const data1 = {
            data: {
                employee_id: employeeId,
                kra_kpi_id: kra_kpi_id,
                appraisal_year_id: appraisalyearid,
                department_id: getKraKpiAppraisalForm?.data?.department_id,
                sub_department_id: getKraKpiAppraisalForm?.data?.sub_department_id,
                designation_id: getKraKpiAppraisalForm?.data?.designation_id,
                kra_kpi_answers: appraisalData?.kra_kpi_questions,
                employee_comment: comments,
                employee_document: uploadedFiles,
                employee_pms_score: totalAchievement || getKraKpiAppraisalForm?.data?.employee_pms_score,
                employee_rating: getRating(totalAchievement || getKraKpiAppraisalForm?.data?.employee_pms_score),
                reviewer_id: getKraKpiAppraisalForm?.data?.reviewer_id,
                reporting_manager_id: getKraKpiAppraisalForm?.data?.reporting_manager_id



            },
            method: getKraKpiAppraisalForm?.data?.employee_appraisal_score_editable && getKraKpiAppraisalForm?.data?.appraisal_current_status === "pending" ? "put" : "post",
            apiName: getKraKpiAppraisalForm?.data?.employee_appraisal_score_editable && getKraKpiAppraisalForm?.data?.appraisal_current_status === "pending" ? `updateEmployeeEvaluation/${getKraKpiAppraisalForm?.data?.kra_kpi_answer_id}}` : `createKraKpiAnswer`
        };
        const responseData = await dispatch(getKraKpiAppraisalForm?.data?.employee_appraisal_score_editable && getKraKpiAppraisalForm?.data?.appraisal_current_status === "pending" ? actions.UPDATEEMPLOYEEEVALUATION(data1) : actions.CREATEKRAKPIANSWER(data1));

        if (responseData?.payload?.message === "KRA/KPI answer saved successfully.") {
            setLoading(false)
            toast.success("KRA/KPI answer saved successfully.")
            setAppraisalData([])
            setComments("")
            setUploadedFiles([])
            setQuestionSectionData([])
            setTimeout(() => {
                navigate("/employee/myappraisal")
            }, 2500)

        }
        else if (responseData?.payload?.message === "Employee evaluation updated successfully. Email sent to manager.") {
            setLoading(false)
            toast.success("Employee evaluation updated successfully.")
            setAppraisalData([])
            setComments("")
            setUploadedFiles([])
            setQuestionSectionData([])
            setTimeout(() => {
                navigate("/employee/myappraisal")
            }, 2500)

        }

        else {
            setLoading(false)
            toast.error(responseData?.payload?.message)
        }


    };


    const responseShowData = {
        maganerReviewerRatingShow: true,


    }

    // const { krakpiid_employeeid_appraisalyearid } = useParams()
    // console.log(krakpiid_employeeid_appraisalyearid, "krakpiid_employeeid_appraisalyearid")
    const location = useLocation();
    const { kra_kpi_id, employeeId, appraisalyearid } = location.state || {};
    // const number = 111;
    // const digits = krakpiid_employeeid_appraisalyearid.toString().split('').map(Number); // [1, 1, 1]
    // console.log(digits, "digits");

    const dispatch = useDispatch()


    useEffect(() => {
        const fetchData = async () => {

            const data1 = {
                data: {
                    employee_id: employeeId,
                    kra_kpi_id: kra_kpi_id,
                    appraisal_year_id: appraisalyearid
                },
                method: "post",
                apiName: `getKraKpiAppraisalForm`
            };
            const responseData = await dispatch(actions.GETKRAKPIAPPRAISALFORM(data1));
            console.log(responseData, "responseData")
            if (responseData?.payload?.message === "getEmployeeKraKpiByAppraisalForm get successfully.") {

                setUploadedFiles(responseData?.payload?.data?.employee_document)
                // setAppraisalData(responseData?.payload?.data)
                const rawData = responseData?.payload?.data
                setResponseApiData(rawData)

                console.log(rawData, "raaaaaaaa")
                // const data2 = {
                //     data: {},
                //     method: "get",
                //     apiName: `getKraKpiById/${rawData?.kra_kpi_id}`
                // };
                // const responseKKraKpiNameData = await dispatch(actions.GETKRAKPIDBYID(data2));
                // console.log(responseKKraKpiNameData, "responseKKraKpiNameData")

                // const data3 = {
                //     data: {},
                //     method: "get",
                //     apiName: `getAppraisalYearById/${rawData?.appraisal_year_id}`
                // };
                // const responseAppraisaYearData = await dispatch(actions.GETAPPRAISALYEARBYID(data3));
                // console.log(responseAppraisaYearData, "responseAppraisaYearData")

                // if (responseData?.payload?.message === "All kra_kpi_id fetched successfully.") {
                //     setEditData(responseData?.payload?.data)
                // }
                const kraKpiId = `KRAKPI${rawData?.kra_kpi_name?.replace(/\s+/g, "")}${rawData?.appraisal_year?.split("-")[1]}`;
                // const kraKpiId = rawData?.appraisal_current_status === "employee evaluation completed" ? `KRAKPI${responseKKraKpiNameData?.payload?.data?.kra_kpi_name?.replace(/\s+/g, "")}${responseAppraisaYearData?.payload?.data?.appraisal_year?.split("-")[1]}` : `KRAKPI${rawData?.kra_kpi_name?.replace(/\s+/g, "")}${rawData?.appraisal_year?.split("-")[1]}`;

                console.log(kraKpiId, "12222")

                // setSelectedKraId(rawData?.kra_kpi_id)
                // setSelectedYearId(rawData?.appraisal_year_id)
                // setKraKpiId(kraKpiId)
                // setSelectedKra(rawData?.kra_kpi_name)

                // setSelectedYear(rawData?.appraisal_year)
                console.log(rawData?.appraisal_current_status !== "not started" ? rawData?.kra_kpi_answers : rawData?.kra_kpi_questions, "rawData")

                // const sections = rawData?.kra_kpi_questions?.map(
                // const sections = rawData?.appraisal_current_status === "employee evaluation completed" ? rawData?.kra_kpi_answers : rawData?.kra_kpi_questions?.map(
                // const sections = (rawData?.appraisal_current_status === "employee evaluation completed" ? rawData?.kra_kpi_answers : rawData?.kra_kpi_questions)?.map(
                const sections = (
                    rawData?.appraisal_current_status !== "not started"
                        ? rawData?.kra_kpi_answers
                        : rawData?.kra_kpi_questions
                ) ?? [];
                console.log(sections, "sectionss")
                const mappedSections = sections?.map(
                    (kraValue, kraKey) => ({

                        kraId: `${kraKpiId}_${`KRA_0${kraKey + 1}`}`,
                        // const kraId = `${kraKpiId}`;

                        kratitle: kraValue?.[`KRA_0${kraKey + 1}`]?.Parameter,
                        weight: kraValue?.[`KRA_0${kraKey + 1}`]?.Weightage,
                        TotalAchievement: kraValue?.[`KRA_0${kraKey + 1}`]?.TotalAchievement,



                        kpis: kraValue?.[`KRA_0${kraKey + 1}`]?.KPIs?.map((kpiValue, kpiKey) => ({
                            kpiId: `${kraKpiId}_${`KRA_0${kraKey + 1}_KPI_0${kpiKey + 1}`}`,
                            parameter: kpiValue?.[`KRA_0${kraKey + 1}_KPI_0${kpiKey + 1}`]?.Parameter,
                            weight: String(kpiValue?.[`KRA_0${kraKey + 1}_KPI_0${kpiKey + 1}`]?.Weightage),
                            achievementPercentage: kpiValue?.[`KRA_0${kraKey + 1}_KPI_0${kpiKey + 1}`]?.achievementPercentage,
                            Achievement: kpiValue?.[`KRA_0${kraKey + 1}_KPI_0${kpiKey + 1}`]?.Achievement
                        }))


                    }))
                console.log(mappedSections, "sectionssectionssections")
                setQuestionSectionData(mappedSections)
            }


        }
        fetchData()

    }, [])

    const employeeDetails = [
        { label: 'Employee Name', value: getKraKpiAppraisalForm?.data?.employee_name || "--" },
        { label: 'Employee Code', value: getKraKpiAppraisalForm?.data?.employee_code || "--" },
        { label: 'Reporting Manager', value: getKraKpiAppraisalForm?.data?.reporting_manager_name || "--" },
        { label: 'Reviewer Name', value: getKraKpiAppraisalForm?.data?.reviewer_name || "--" },
        { label: 'Department', value: getKraKpiAppraisalForm?.data?.department_name || "--" },
        { label: 'Sub Department', value: getKraKpiAppraisalForm?.data?.sub_department_name || "--" },

        { label: 'Designation', value: getKraKpiAppraisalForm?.data?.designation_name || "--" },

        { label: 'KRA_KPI_ID', value: `KRAKPI${getKraKpiAppraisalForm?.data?.kra_kpi_name?.replace(/\s+/g, "")}${getKraKpiAppraisalForm?.data?.appraisal_year?.split("-")[1]}` || "--" },
        { label: 'DOJ', value: getKraKpiAppraisalForm?.data?.date_of_joining || "--" },
    ];


    // Set initial value when data is available
    useEffect(() => {
        if (getKraKpiAppraisalForm?.data?.employee_comment) {
            setComments(getKraKpiAppraisalForm.data.employee_comment);
        }
    }, [getKraKpiAppraisalForm?.data?.employee_comment]);


    return (
        <Box>
            {loading && <FullPageLoader />}
            {/* Header and employee details */}
            <Box sx={{ background: "white", p: 3 }}>
                <Typography variant='subtitle2' sx={{ color: "black", fontSize: "18px", mb: 4 }}>
                    PERFORMANCE OF THE YEAR {getKraKpiAppraisalForm?.data?.appraisal_year}
                </Typography>
                <Grid container spacing={4}>
                    {employeeDetails.map((data, idx) => (
                        <Grid key={idx} size={{ xs: 12, md: 6 }}>
                            <Typography variant='subtitle2' sx={{ color: "gray" }}>
                                {data.label}: {data.value}
                            </Typography>
                        </Grid>
                    ))}
                </Grid>
            </Box>

            {/* Appraisal Form */}
            <Box sx={{ mt: 4 }}>
                <AppraisalFormComponent onDataChange={setAppraisalData}
                    questionSectionData={questionSectionData} getKraKpiAppraisalForm={getKraKpiAppraisalForm} />

            </Box>

            {/* Documents */}
            {/* {getKraKpiAppraisalForm?.data?.employee_document?.length > 0 && ( */}
                <Box sx={{ background: "white", p: 3, mt: 4 }}>

                    <Typography variant='subtitle2' sx={{ fontSize: "18px", mb: 4, color: "black" }}>
                        Documents
                    </Typography>
                    <FileUploadWithPreview setUploadedFiles={setUploadedFiles} uploadedFiles={uploadedFiles} getKraKpiAppraisalForm={getKraKpiAppraisalForm} />
                </Box>
            {/* )} */}
            {/* Pms score */}
            {getKraKpiAppraisalForm?.data?.pms_score_show && (
                <Box sx={{ background: "white", p: 3, mt: 4 }}>
                    <Typography variant='subtitle2' sx={{ fontSize: "18px", mb: 4, color: "black" }}>
                        Rating
                    </Typography>

                    <>
                        <EmployeePMSRating getKraKpiAppraisalForm={getKraKpiAppraisalForm} />
                        <Box>
                            <RatingTable />
                        </Box>
                    </>

                </Box>
            )}



            {/* Comments */}
            <Box sx={{ background: "white", p: 3, mt: 4 }}>
                <Typography variant='subtitle2' sx={{ fontSize: "18px", mb: 4, color: "black" }}>
                    Comments
                </Typography>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 8 }}>
                        <label>
                            <Typography variant="subtitle1" sx={{ color: "gray", fontSize: "15px", mb: 1 }}>
                                Assessee Comments
                            </Typography>
                        </label>
                        <TextField
                            fullWidth
                            size="small"
                            multiline
                            rows={4}
                            // value={getKraKpiAppraisalForm?.data?.employee_comment || comments}
                            value={comments}
                            onChange={(e) => setComments(e.target.value)}

                            sx={{ background: !getKraKpiAppraisalForm?.data?.employee_appraisal_score_editable && "#f0f0f0" }}
                            disabled={
                                // getKraKpiAppraisalForm?.data?.appraisal_current_status !== "not started"
                                !getKraKpiAppraisalForm?.data?.employee_appraisal_score_editable

                            }
                        />
                    </Grid>
                    {getKraKpiAppraisalForm?.data?.pms_score_show && (
                        <>
                            {getKraKpiAppraisalForm?.data?.manager_comment && (
                                <Grid size={{ xs: 12, md: 8 }}>
                                    <label>
                                        <Typography variant="subtitle1" sx={{ color: "gray", fontSize: "15px", mb: 1 }}>
                                            Manager Comments
                                        </Typography>
                                    </label>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        multiline
                                        disabled
                                        rows={4}
                                        value={getKraKpiAppraisalForm?.data?.manager_comment}
                                        // onChange={(e) => setComments(e.target.value)}
                                        sx={{ background: "#f0f0f0" }}

                                    />
                                </Grid>
                            )}
                            {getKraKpiAppraisalForm?.data?.reviewer_comment && (
                                <Grid size={{ xs: 12, md: 8 }}>
                                    <label>
                                        <Typography variant="subtitle1" sx={{ color: "gray", fontSize: "15px", mb: 1 }}>
                                            Reviewer Comments
                                        </Typography>
                                    </label>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        disabled
                                        multiline
                                        rows={4}
                                        value={getKraKpiAppraisalForm?.data?.reviewer_comment}
                                        // onChange={(e) => setComments(e.target.value)}//
                                        sx={{ background: "#f0f0f0" }}

                                    />
                                </Grid>
                            )}
                        </>
                    )}
                </Grid>
                {getKraKpiAppraisalForm?.data?.manager_reject_comment && (
                    <>
                        <Typography variant='subtitle2' sx={{ mt: 2, color: "black" }}>
                            Manager Reject Comment
                        </Typography>
                        <Typography variant='subtitle1' sx={{ color: "gray", ml: 2 }}>
                            {getKraKpiAppraisalForm?.data?.manager_reject_comment}
                        </Typography>


                    </>
                )}
                {
                    // getKraKpiAppraisalForm?.data?.appraisal_current_status === "not started" &&
                    getKraKpiAppraisalForm?.data?.employee_appraisal_score_editable &&

                    <Button onClick={handleSubmit} variant="contained" sx={{ mt: 2, background: "var(--main-color)" }}>
                        Submit
                    </Button>}
                {/* <Box sx={{ background: "white", mt: 4 }}>

                    <AppraisalHistory />


                </Box> */}

                {/* <PDFExport
                    employeeDetails={employeeDetails} // your real-time response-based array
                    tableData={questionSectionData.map(kra => ({
                        KraId: kra.kraId,
                        questionHeading: kra.kratitle,
                        actualWeitage: kra.weight || '--',
                        againstWeightage: kra.TotalAchievement || '--',
                        kpi: kra.kpis.map((kpi, index) => ({
                            kraKpi: `${kra.kraId}_KPI_0${index + 1}`,
                            parameter: kpi.parameter || "--",
                            weightage: kpi.weight || "--",
                            achievement: kpi.Achievement || "--",
                            againstWeightage: kpi.achievementPercentage || "--"
                        }))
                    }))}
                /> */}

            </Box>
            <ToastContainer
                position="top-right" // or "top-center", "bottom-left", etc.
                autoClose={1500} // Auto close duration in ms
                hideProgressBar={false} // Hide or show progress bar
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
            />
        </Box>
    );
};

export default MyAppraisalForm;
